import React, { useRef, useState, useEffect }  from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { apiServices } from "../../services/apiServices";


const Glucose = (userData)=> {
  const chartRef = useRef(null);
  const [randomindicatorValues, setrandomindicatorValues] = useState([]);
  const [fastingindicatorValues, setfastingindicatorValues] = useState([]);
  const [monthNames, setmonthNames] = useState([]);
  const [maxDates, setmaxDates] = useState([]);

  useEffect(() => {
    let oRequest = {
      "param1":userData.userData.userData.userData.programOwners[0].program,
      "param2":userData.userData.userData.userData.orgUnit, 
      "param3":userData.userData.userData.userData.trackedEntityInstance
    }
  apiServices.postAPI('dashboardIndicator/getPatientData/get_custom_dashboard_glucosedetails', oRequest)
  .then((res) => {
    const randomValues = [];
    const fastingValues = [];
    const months = [];
    const dates = [];
 

    res.data.data.forEach(item => {
      
      if (item.indicatornames === "Blood glucose - Random") {
        randomValues.push(item.indicatorvalue);
        dates.push(item.maxdate);
        months.push(item.monthname.trim());
        } else if (item.indicatornames === "Blood glucose - Fasting") {
            fastingValues.push(item.indicatorvalue);
        } else {
            randomValues.push(0);
            fastingValues.push(0);
        }
    });
  setrandomindicatorValues(randomValues);
  setfastingindicatorValues(fastingValues); 
  setmonthNames(months);  
  setmaxDates(dates);
  })
  .catch((error) => {
    console.log("error",error)
  })
  }, []);
  const data1 = fastingindicatorValues;
  const data2 = randomindicatorValues;

const indexOfThree = data1.indexOf(125);
const indexOfFour = data1.indexOf(140);
const indexOfLthree = data2.indexOf(180);
const indexOfLfour = data2.indexOf(165);

  const seriesData = data1.map((value, index) => ({
    y: value,
    marker: {
      fillColor: index === indexOfThree || index === indexOfFour ? '#ff779e' : '#cbd196'
    },

  }));
  
  const seriesData2 = data2.map((value, index) => ({
    y: value,
    marker: {
      fillColor: index === indexOfLthree || index === indexOfLfour ? '#ff779e' : '#00acb1'
    }
  }));

  const options = {
    title: {
      text: '',
      align: 'left',
      x: 10,
      y: 10
    },
    credits: {
      enabled: false,
  },
    xAxis: {
      categories: monthNames,
    },
    yAxis: {
      title: {
        text: ''
      },
      labels: {
        enabled: false
      },
      // tickPositions: [25,50,75,100,125,150,175,200],  
      tickInterval: 3
    },
    chart: {
      type:'line',
      zoomType: 'none',
      resetZoomButton: false,
      backgroundColor: 'transparent',
      height:'250',
    },
    exporting:{
      enabled:true,
  },
//   tooltip: {
//     headerFormat: '<span style="font-size:11px">{point.x}</span><br>',
//     pointFormat: '<span style="color:{point.color}">{point.name}</span>: ' +
//         '<b>{point.y}</b>'
// },
    series: [{
      name: 'FASTING GLUCOSE',
      connectNulls: true,
      color:"#4472c4",
      lineColor: '#4472c4',
      lineWidth: 5,
      data: seriesData,
      marker: {
        symbol: 'circle',
        radius: 12,
        states: {
          hover: {
            enabled: false
          }
        }
      },
      dataLabels: {
        enabled: true,
        format: '{y}',
        style: {
          color: 'white',
          textOutline: 'none',
          // fontWeight: 'bold'
        },
        align: 'center',
        verticalAlign: 'middle'
      },
    }, {
      name: 'RANDOM GLUCOSE',
      color:"#ed7d31",
      connectNulls: true,
      lineColor: '#ed7d31',
      lineWidth: 5,
      data: seriesData2,
      marker: {
        symbol: 'circle',
        radius: 12,
        states: {
          hover: {
            enabled: false
          }
        }
      },
      dataLabels: {
        enabled: true,
        format: '{y}',
        style: {
          color: 'white',
          textOutline: 'none',
          // fontWeight: 'bold'
        },
        align: 'center',
        verticalAlign: 'middle'
      }
    }]
  }
  useEffect(() => {
    if (!chartRef.current) return;


  }, []);

  return (
    <div>
     <HighchartsReact
        highcharts={Highcharts}
        options={options}
      />
    </div>
//   <div ref={chartRef} />

    );
}

export default Glucose;
// ReactDOM.render(<SimpleLineChart />, document.getElementById('container'));
